require('./style.scss')
class MenuHeaderDirective
  @$inject: ['$rootScope']
  constructor: ($rootScope)->                
    class MenuHeader
      restrict: "C"
      template: require('./index.pug')      
      link: ($scope, $element, attrs, controller)->
    return new MenuHeader()

  
module.exports = MenuHeaderDirective


// WEBPACK FOOTER //
// ./src/component/menu/header/index.coffee